import styled from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { breakpoints } from '@/config/layout'

import type { ComponentProps } from 'react'

export const BookingFlowLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
`

export const BookingFlowContent = styled(FlexColumn)`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space3};
  padding: ${({ theme }) => theme.UI.SpacingPx.Space4};
  overflow-y: auto;
`

const CenteredContent = styled(FlexColumn)`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space3};
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
`

export const BookingFlowActionsWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.Colors.Neutrals.Lightest};
  padding: ${({ theme }) => theme.UI.SpacingPx.Space4};
  padding-top: ${({ theme }) => theme.UI.SpacingPx.Space6};
  padding-bottom: calc(
    max(var(--safe-area-inset-bottom, 0px), 20px) +
      ${({ theme }) => theme.UI.Spacing.Space1}px
  );
  @media (${breakpoints.fromM}) {
    padding-bottom: calc(
      max(var(--safe-area-inset-bottom, 0px), 20px) +
        ${({ theme }) => theme.UI.Spacing.Space6}px
    );
  }
  flex: 0 0 auto;
  z-index: 10;

  box-shadow:
    0px 0px 70px rgba(205, 208, 213, 0.15),
    0px 0px 10px rgba(170, 179, 193, 0.12);
`

export function BookingFlowCenteredContent({ children, ...props }: ComponentProps<typeof CenteredContent>) {
  return (
    <BookingFlowContent>
      <CenteredContent {...props}>{children}</CenteredContent>
    </BookingFlowContent>
  )
}

export function BookingFlowActions({ children, ...props }: ComponentProps<typeof CenteredContent>) {
  return (
    <BookingFlowActionsWrapper>
      <CenteredContent {...props}>{children}</CenteredContent>
    </BookingFlowActionsWrapper>
  )
}
